var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    {
      attrs: { id: "sync-status-card" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c("h2", { staticClass: "section-separator-title" }, [
                _c("div", { staticClass: "d-flex align-items-center" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("filogix.expertSync.yourSyncStatus")) +
                      "\n        "
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "h6 m-0",
                      attrs: { id: "filogix-sync-tooltip" },
                    },
                    [
                      _c("icon", {
                        staticClass: "tooltip-info",
                        attrs: { name: "question-circle" },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex align-items-center mb-2" },
        [
          _c("h5", { staticClass: "bold mb-0", class: _vm.syncTextVariant }, [
            _vm._v("\n      " + _vm._s(_vm.status.message) + "\n    "),
          ]),
          _vm._v(" "),
          _vm.showRetryButton || _vm.status.syncing
            ? _c("sync-refresh", {
                attrs: {
                  loading:
                    _vm.retrying ||
                    _vm.updatingSyncStatus ||
                    _vm.status.syncing,
                  "tooltip-title": _vm.$t("filogix.expertSync.retrySync"),
                },
                on: { refresh: _vm.handleRetry },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDetailsText
        ? [
            _vm.isUnableToSync && _vm.status.code === "unable-to-sync"
              ? _c("i18n", {
                  attrs: { path: _vm.errorMessagePath, tag: "p" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "link",
                        fn: function () {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass: "text-primary clickable",
                                attrs: {
                                  to: {
                                    path: "/personal-settings/account/filogix-details",
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "settings.accountTab.lenderSubmissionDetails"
                                      )
                                    ) +
                                    "\n          "
                                ),
                                _c("icon", {
                                  attrs: { name: "external-link" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    357939412
                  ),
                })
              : _c("p", [
                  _vm._v(
                    "\n      " + _vm._s(_vm.status.description) + "\n    "
                  ),
                ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("p", { staticClass: "title mb-0 mt-4" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("filogix.expertSync.latestSyncStatus")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-0" }, [
        _c("span", { staticClass: "bold" }, [
          _vm._v(" " + _vm._s(_vm.$t("global.words.date")) + ": "),
        ]),
        _vm._v(
          "\n    " +
            _vm._s(_vm._f("formatDateHour")(_vm.status.createdAt)) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.status.eventType
        ? _c(
            "p",
            { staticClass: "mb-0" },
            [
              _c("span", { staticClass: "bold" }, [
                _vm._v(" " + _vm._s(_vm.$t("application-form.type")) + ": "),
              ]),
              _vm._v(" "),
              _c(
                "badge",
                {
                  staticClass: "m-0 badge-notification float-none",
                  attrs: { type: _vm.status.isError ? "danger" : "primary" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.getApplicationSyncEventTypeText(
                          _vm.status.eventType
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.status.title
        ? _c("p", { staticClass: "mb-0" }, [
            _c("span", { staticClass: "bold" }, [
              _vm._v(" " + _vm._s(_vm.$t("global.words.message")) + ": "),
            ]),
            _vm._v("\n    " + _vm._s(_vm.status.title) + "\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isUnableToSync && _vm.status.syncing
        ? _c(
            "p",
            { staticClass: "mb-0" },
            [
              _c("span", { staticClass: "bold" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("filogix.expertSync.errorDetails")) + ": "
                ),
              ]),
              _vm._v(" "),
              _c("i18n", {
                staticClass: "m-0",
                attrs: { path: _vm.errorMessagePath, tag: "p" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "link",
                      fn: function () {
                        return [
                          _c(
                            "router-link",
                            {
                              staticClass: "text-primary clickable",
                              attrs: {
                                to: {
                                  path: "/personal-settings/account/filogix-details",
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "settings.accountTab.lenderSubmissionDetails"
                                    )
                                  ) +
                                  "\n          "
                              ),
                              _c("icon", { attrs: { name: "external-link" } }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  357939412
                ),
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }